import React from 'react'
import './Table.css'
import numeral from 'numeral'

function Table({countries, caseType}) {
    return (
        <div className="table">
            {countries.map(({country,[caseType]: cases}) => (
                <tr>
                    <td>{country}</td>
                    <td><strong>{numeral(cases).format("0,0")}</strong></td>
                </tr>
                
            ))}
        </div>
    )
}

export default Table
